import React, { FC, useState } from 'react'

import { CardWrapper } from '../CardWrapper/CardWrapper'
import { CardItem } from '../CardItem/CardItem'

import { getMembershipDate, isExpiredMembership } from '../../../../../../helpers/requiredFields'
import { useProfile } from '../../../../../../hooks/useProfile'

import { IHorseData } from '../../../../../../models/horse/horse.interface'
import { IHorsesWithPaperwork } from '../../tabs/HorsesTab/HorsesTab'

const getDefaultValue = (
  number: string | number | undefined,
  endDate: string | Date | undefined
) => {
  return `${number}${endDate && ` , ${getMembershipDate(endDate)}`}`
}

interface HorseMembershipsCardProps {
  index: number
  horse: IHorseData
  horsesWithPaperwork: IHorsesWithPaperwork[]
  setHorsesWithPaperwork: (state: IHorsesWithPaperwork[]) => void
  isEditable?: boolean
}

export const HorseMembershipsCard: FC<HorseMembershipsCardProps> = ({
  index,
  horsesWithPaperwork,
  setHorsesWithPaperwork,
  horse,
  isEditable,
}) => {
  const { onSaveEditHorse, onCancelEditHorse, onChangeHorseInput } = useProfile()

  const [isEdit, setIsEdit] = useState(false)

  return (
    <CardWrapper
      title="Memberships"
      onSaveEdit={() => onSaveEditHorse({ index, horsesWithPaperwork, setIsEdit })}
      onCancelEdit={() =>
        onCancelEditHorse({ index, horsesWithPaperwork, setHorsesWithPaperwork, setIsEdit })
      }
      isEditable={isEditable}
      isEdit={isEdit}
      setIsEdit={setIsEdit}
    >
      <CardItem
        fieldType="number"
        fieldKey="horseUsefNumber"
        label="USEF membership"
        defaultValue={getDefaultValue(horse.horseUsefNumber, horse.horseUsefExpiration)}
        url={horse.horseUsefImage}
        isInvalid={!horse.horseUsefNumber || !horse.horseUsefExpiration}
        isMissing={!horse.horseUsefNumber}
        isExpired={isExpiredMembership(horse.horseUsefExpiration)}
        showLabelError={true}
        isEdit={isEdit}
        onChange={({ fieldName, fieldType, fieldKey, option }) =>
          onChangeHorseInput({
            fieldName,
            fieldType,
            fieldKey,
            option,
            index,
            horsesWithPaperwork,
            setHorsesWithPaperwork,
          })
        }
      />
      <CardItem
        fieldType="number"
        fieldKey="horseFeiNumber"
        label="FEI membership"
        defaultValue={getDefaultValue(horse.horseFeiNumber, horse.horseFeiExpiration)}
        url={horse.horseFeiImage}
        isInvalid={!horse.horseFeiNumber || !horse.horseFeiExpiration}
        isMissing={!horse.horseFeiNumber}
        isExpired={isExpiredMembership(horse.horseFeiExpiration)}
        showLabelError={true}
        isEdit={isEdit}
        onChange={({ fieldName, fieldType, fieldKey, option }) =>
          onChangeHorseInput({
            fieldName,
            fieldType,
            fieldKey,
            option,
            index,
            horsesWithPaperwork,
            setHorsesWithPaperwork,
          })
        }
      />
      <CardItem
        fieldType="number"
        fieldKey="horseUsdfNumber"
        label="USDF membership"
        defaultValue={getDefaultValue(horse.horseUsdfNumber, horse.horseUsdfExpiration)}
        url={horse.horseUsdfImage}
        isInvalid={!horse.horseUsdfNumber || !horse.horseUsdfExpiration}
        isMissing={!horse.horseUsdfNumber}
        isExpired={isExpiredMembership(horse.horseUsdfExpiration)}
        showLabelError={true}
        isEdit={isEdit}
        onChange={({ fieldName, fieldType, fieldKey, option }) =>
          onChangeHorseInput({
            fieldName,
            fieldType,
            fieldKey,
            option,
            index,
            horsesWithPaperwork,
            setHorsesWithPaperwork,
          })
        }
      />
      <CardItem
        fieldType="number"
        fieldKey="horseAhaNumber"
        label="AHA membership"
        defaultValue={getDefaultValue(horse.horseAhaNumber, horse.horseAhaExpiration)}
        url={horse.horseAhaImage}
        isInvalid={!horse.horseAhaNumber || !horse.horseAhaExpiration}
        isMissing={!horse.horseAhaNumber}
        isExpired={isExpiredMembership(horse.horseAhaExpiration)}
        showLabelError={true}
        isEdit={isEdit}
        onChange={({ fieldName, fieldType, fieldKey, option }) =>
          onChangeHorseInput({
            fieldName,
            fieldType,
            fieldKey,
            option,
            index,
            horsesWithPaperwork,
            setHorsesWithPaperwork,
          })
        }
      />
    </CardWrapper>
  )
}
